import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-UpArrow",
  "use": "svg-icon-UpArrow-usage",
  "viewBox": "0 0 16 9",
  "content": "<symbol viewBox=\"0 0 16 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-UpArrow\"><path d=\"M8 0l1.1 1.088 6.672 6.599c.304.3.304.787 0 1.088-.303.3-.796.3-1.1 0L8 2.175l-6.672 6.6c-.304.3-.796.3-1.1 0a.763.763 0 0 1 0-1.088l6.672-6.6L8 0z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol